var EntitiesBase = require('../../entities/base_rest');
var MenuProductModel = EntitiesBase.ModelBase.extend({
    constructor: function(attrs, options) {
        EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
    },
    urlRoot: function () {
        return farmacy.settings.restAPI.root + 'wp/v3/menu-products';
    }
});
_.extend(MenuProductModel.prototype, Backbone.Validation.mixin);

var PageableMenuProductsCollection = EntitiesBase.PageableCollectionBase.extend({
    url: function () {
        return farmacy.settings.restAPI.root + 'wp/v3/menu-products';
    },
    constructor: function(models, options) {
        EntitiesBase.PageableCollectionBase.prototype.constructor.call(this, models, options);
    },
    state: _.extend(
        {},
        EntitiesBase.PageableCollectionBase.prototype.state,
        {
            sortKey: 'title',
            order: EntitiesBase.SORT_DIRECTIONS.ASC
        }
    ),
    model: MenuProductModel
});

module.exports = {
    MenuProductModel: MenuProductModel,
    PageableMenuProductsCollection: PageableMenuProductsCollection
};



/** WEBPACK FOOTER **
 ** ./assets/js/admin-app/entities/menu-product-base.js
 **/